import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import {
  Grid,
  FormControlLabel,
  Radio,
  RadioGroup,
  Select,
  MenuItem,
  FormControl,
  Typography,
} from '@mui/material'
import NumberFormat from 'react-number-format'

export function TextInput({
  label,
  idAdaptabilityQuestion,
  className,
  options,
  handleChange,
  valueObject,
  type,
  level,
  error,
  errorMessage,
  isGroupResponse,
  parentValue,
  parentValueType,
  disabled,
}) {
  const value = valueObject?.Answer ?? ''

  return (
    <>
      {!isGroupResponse ? (
        <Grid container spacing={2} clasName="input__container">
          <Grid item xs={12} sm={12} md={12}>
            <FormControl fullWidth>
              <TextField
                id="outlined-basic"
                variant="outlined"
                value={value}
                onChange={(e) => {
                  const newValue = e.target.value
                  handleChange(idAdaptabilityQuestion, newValue, level, type)
                }}
                inputProps={{
                  maxlength: 50,
                }}
                error={error}
                disabled={disabled}
              />
            </FormControl>
            {error ? (
              <div
                style={{
                  color: 'red',
                  marginTop: '3px',
                  fontSize: '13px',
                }}
              >
                {errorMessage}
              </div>
            ) : null}
          </Grid>
        </Grid>
      ) : (
        <>
          <CustomizerInput
            label={label}
            idAdaptabilityQuestion={idAdaptabilityQuestion}
            className={className}
            options={options}
            handleChange={handleChange}
            valueObject={valueObject}
            valueArray={Number(parentValue)}
            type={type}
            level={level}
            error={error}
            errorMessage={errorMessage}
            disabled={disabled}
          />
        </>
      )}
    </>
  )
}

export function NumberInput({
  label,
  idAdaptabilityQuestion,
  error,
  errorMessage,
  handleChange,
  valueObject,
  type,
  parentValueType,
  level,
  disabled,
}) {
  const value = valueObject?.Answer

  return (
    <>
      <Grid container spacing={2} clasName="input__container">
        {label && parentValueType !== InputTypes.SUBCATEGORY && (
          <Grid item xs={12} sm={12} md={12}>
            <label className="responsiveLabel">{label}</label>
          </Grid>
        )}

        <Grid item xs={12} sm={12} md={12}>
          <FormControl fullWidth>
            <NumberFormat
              id="outlined-number"
              customInput={TextField}
              InputLabelProps={{
                shrink: true,
              }}
              value={value}
              onChange={(e) => {
                const newValue = e.target.value.replaceAll(',', '')
                handleChange(idAdaptabilityQuestion, newValue, level, type)
              }}
              inputProps={{ maxLength: 18 }}
              allowNegative={false}
              thousandSeparator={true}
              decimalScale={type === InputTypes.NUMERIC ? 0 : 2}
              error={error}
              disabled={disabled}
            />
          </FormControl>
          {error ? (
            <div
              style={{
                color: 'red',
                marginTop: '3px',
                fontSize: '13px',
              }}
            >
              {errorMessage}
            </div>
          ) : null}
        </Grid>
      </Grid>
    </>
  )
}

export function AutoCompleteInput({
  label,
  idAdaptabilityQuestion,
  className,
  options,
  handleChange,
  valueObject,
  type,
  level,
  error,
  errorMessage,
  disabled,
}) {
  /** Tipo: Subcategoria */
  const isSubCategory = type === InputTypes.SUBCATEGORY

  const valueObj =
    options?.find((data) => {
      return isSubCategory
        ? data.id === valueObject?.IdAdaptabilityQuestion
        : data.id === valueObject?.Answer
    }) || null

  const idQuestion = isSubCategory
    ? valueObj?.id ?? null
    : idAdaptabilityQuestion

  return (
    <Grid container spacing={2} clasName="input__container">
      <Grid item xs={12} sm={12} md={12}>
        {level === 1 && (
          <div>
            <Typography>Pregunta Secundaria</Typography>
          </div>
        )}

        {type !== 6 && <label className="responsiveLabel">{label}</label>}
        <Autocomplete
          id="category-autocomplete"
          options={options || []}
          getOptionLabel={(option) => option?.label}
          renderInput={(params) => (
            <TextField
              error={error}
              name={String(idAdaptabilityQuestion)}
              {...params}
              variant="outlined"
            />
          )}
          value={valueObj}
          disabled={disabled}
          onChange={(e, value) => {
            let id = idQuestion ?? null
            let questionValue = value?.id
            // console.log({id, questionValue})
            if (isSubCategory) {
              id = value?.id ?? null
              questionValue = true
            }
            handleChange(id, questionValue, level, type)
          }}
        />
        {error ? (
          <div
            style={{
              color: 'red',
              marginTop: '3px',
              fontSize: '13px',
            }}
          >
            {errorMessage}
          </div>
        ) : null}
      </Grid>
    </Grid>
  )
}

export function CustomizerInput({
  valueObject,
  valueArray,
  handleChange,
  error,
  errorMessage,
  idAdaptabilityQuestion,
  level,
  type,
  label,
  disabled,
}) {
  console.log('value', label)
  let value = []

  if (
    valueObject !== null &&
    valueObject !== undefined &&
    valueObject?.Answer !== null
  ) {
    value = valueObject?.Answer?.split('|')
  }

  const setValues = (target, index) => {
    const newValue = [...value]
    newValue[index] = target

    handleChange(idAdaptabilityQuestion, newValue.join('|'), level, type)
  }

  return (
    <>
      <Grid container spacing={1} clasName="input__container">
        <Grid item xs={12} sm={12} md={12}>
          <label className="responsiveLabel">{label}</label>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          {Array(valueArray)
            .fill(null)
            .map((item, index) => (
              <Grid
                container
                spacing={2}
                clasName="input__container"
                key={index}
              >
                <Grid item xs={12} sm={12} md={12}>
                  <TextField
                    name="MiPymeCountry"
                    type="text"
                    value={value.length > 0 ? value[index] : ''}
                    variant="outlined"
                    sx={{ width: '100%' }}
                    onChange={(e) => {
                      setValues(e.target.value, index)
                    }}
                    error={error}
                    disabled={disabled}
                  />
                </Grid>
              </Grid>
            ))}
          {error ? (
            <div
              style={{
                color: 'red',
                marginTop: '3px',
                fontSize: '13px',
              }}
            >
              {errorMessage}
            </div>
          ) : null}
        </Grid>
      </Grid>
    </>
  )
}

export function RadioButtonInput({
  valueObject,
  handleChange,
  level,
  type,
  error,
  errorMessage,
  idAdaptabilityQuestion,
  disabled,
}) {
  const value = valueObject?.Answer ?? false
  console.log('radioButton', valueObject)
  return (
    <Grid container spacing={2} clasName="input__container">
      <Grid item xs={12} sm={12} md={12}>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          value={value}
          name="radio-buttons-group"
          onChange={(e) => {
            console.log(e.target.value)

            // const newValue = e.target.value === "true" ? true : false;
            let newValue
            if (e.target.value === 'true') {
              newValue = true
            } else {
              newValue = false
            }
            handleChange(idAdaptabilityQuestion, newValue, level, type)
          }}
        >
          <FormControlLabel
            disabled={disabled}
            value={true}
            control={<Radio />}
            label="Si"
          />
          <FormControlLabel
            disabled={disabled}
            value={false}
            control={<Radio />}
            label="No"
          />
        </RadioGroup>
        {error ? (
          <div
            style={{
              color: 'red',
              marginTop: '3px',
              fontSize: '13px',
            }}
          >
            {errorMessage}
          </div>
        ) : null}
      </Grid>
    </Grid>
  )
}

export function SelectInput({
  valueObject,
  handleChange,
  type,
  level,
  error,
  errorMessage,
  listOptionValues,
  idAdaptabilityQuestion,
  disabled,
}) {
  const value = valueObject?.Answer ?? ''

  return (
    <Grid container spacing={2} clasName="input__container">
      <Grid item xs={12} sm={12} md={12}>
        <FormControl fullWidth>
          <Select
            variant="outlined"
            value={value}
            error={error}
            disabled={disabled}
            onChange={(e) => {
              handleChange(idAdaptabilityQuestion, e.target.value, level, type)
            }}
          >
            <MenuItem disabled value="">
              Seleccione una opción
            </MenuItem>
            {listOptionValues?.split('|').map((item, key) => (
              <MenuItem key={key} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {error ? (
          <div
            style={{
              color: 'red',
              marginTop: '3px',
              fontSize: '13px',
            }}
          >
            {errorMessage}
          </div>
        ) : null}
      </Grid>
    </Grid>
  )
}

export function PorcentInput({
  label,
  idAdaptabilityQuestion,
  error,
  errorMessage,
  handleChange,
  valueObject,
  type,
  parentValueType,
  level,
  disabled,
}) {
  const value = valueObject?.Answer

  return (
    <>
      <Grid container spacing={2} clasName="input__container">
        <Grid item xs={12} sm={12} md={12}>
          <FormControl fullWidth>
            <NumberFormat
              id="outlined-number"
              customInput={TextField}
              InputLabelProps={{
                shrink: true,
              }}
              value={value}
              onChange={(e) => {
                const newValue = e.target.value.replaceAll(',', '')
                handleChange(idAdaptabilityQuestion, newValue, level, type)
              }}
              inputProps={{ maxLength: 18 }}
              allowNegative={false}
              thousandSeparator={true}
              decimalScale={2}
              error={error}
              disabled={disabled}
            />
          </FormControl>
          {error ? (
            <div
              style={{
                color: 'red',
                marginTop: '3px',
                fontSize: '13px',
              }}
            >
              {errorMessage}
            </div>
          ) : null}
        </Grid>
      </Grid>
    </>
  )
}

export const InputTypes = Object.freeze({
  SUBCATEGORY: 6,
  BOOLEAN: 3,
  NUMERIC: 1,
  STRING: 2,
  DECIMAL: 4,
  LISTVALUES: 5,
  PERCENT: 7,
})

/**
 * Sustituye el primer caso que haga match, de la forma (REP_<numero>)
 * @param {String} questionName Cadena a modificar
 * @param {String} parentValue Valor para sustituir
 * @returns
 */
export const formatQuestionName = (questionName, parentValue) => {
  const regex = /\(REP_([0-9]+)\)/g
  const found = questionName.match(regex)
  const newParaGraph = found?.length
    ? questionName.replace(found[0], String(parentValue))
    : questionName
  return newParaGraph
}
